import Skeleton from '@material-ui/lab/Skeleton/Skeleton'

import useStyles from './styles/MonitoringFormListRow.styles'

interface MonitoringFormListRowSkeletonProps {
  isMobile?: boolean
}
const MonitoringFormListRowSkeleton: React.FC<
  MonitoringFormListRowSkeletonProps
> = ({ isMobile }) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      {Array(isMobile ? 3 : 8)
        .fill(null)
        .map((_, index) => (
          <div key={index}>
            <Skeleton animation="wave" className={classes.skeleton} />
          </div>
        ))}
    </div>
  )
}
export default MonitoringFormListRowSkeleton
